//
// GENERATED by KVision
//
package pl.finn.forms.podpp

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.Zalacznik
import pl.finn.forms.podpp.PodppForm
import pl.finn.forms.podpp.PodppFormData

actual class PodppService(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : IPodppService, KVRemoteAgent<PodppService>(PodppServiceManager, serializersModules, requestFilter) {
    override suspend fun nowy(token: String) = call(IPodppService::nowy, token)
    override suspend fun edycja(token: String) = call(IPodppService::edycja, token)
    override suspend fun sprawdz(podppForm: PodppForm, zalaczniki: List<Zalacznik>, token: String) = call(IPodppService::sprawdz, podppForm, zalaczniki, token)
    override suspend fun zapisz(podppForm: PodppForm, zalaczniki: List<Zalacznik>, validateResult: String?, token: String) = call(IPodppService::zapisz, podppForm, zalaczniki, validateResult, token)
    override suspend fun podglad(podppForm: PodppForm, zalaczniki: List<Zalacznik>, token: String) = call(IPodppService::podglad, podppForm, zalaczniki, token)
}
